import { Directive } from "@angular/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";

@Directive()
export abstract class ProductDownloadsBaseComponent extends BaseComponent {
  public text: string = "ProductDownloads";

  constructor(userService: UserService) {
    super(userService);
  }
}
